import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
	REMINDER_ID_PARAM,
	REMINDER_SCROLL_PARAM,
	REMINDER_SCROLL_VALUE,
	REMINDERS_SECTION_ANCHOR_ID,
	reminderRowAnchorId,
} from "web_myplann/NotificationCenter/Utils/reminderScrollParam";
import { REMINDER_HIGHLIGHT_DURATION_MS } from "web_myplann/Shared/Utils/reminder";

export const useScrollToReminderRow = (isLoaded: boolean): string | null => {
	const [searchParams] = useSearchParams();
	const hasScrolledRef = useRef(false);
	const [highlightedReminderId, setHighlightedReminderId] = useState<
		string | null
	>(null);
	const shouldScroll =
		searchParams.get(REMINDER_SCROLL_PARAM) === REMINDER_SCROLL_VALUE;
	const reminderId = searchParams.get(REMINDER_ID_PARAM);

	useEffect(() => {
		if (!shouldScroll || !reminderId || !isLoaded || hasScrolledRef.current) {
			return;
		}
		const row = document.getElementById(reminderRowAnchorId(reminderId));
		const element = row ?? document.getElementById(REMINDERS_SECTION_ANCHOR_ID);
		if (!element) {
			return;
		}
		hasScrolledRef.current = true;
		requestAnimationFrame(() => {
			element.scrollIntoView({ behavior: "smooth", block: "start" });
		});
		if (row) {
			setHighlightedReminderId(reminderId);
		}
	}, [shouldScroll, reminderId, isLoaded]);

	useEffect(() => {
		if (!highlightedReminderId) {
			return;
		}
		const timeout = window.setTimeout(() => {
			setHighlightedReminderId(null);
		}, REMINDER_HIGHLIGHT_DURATION_MS);
		return () => {
			window.clearTimeout(timeout);
		};
	}, [highlightedReminderId]);

	return highlightedReminderId;
};
